import React from "react";
import { motion } from "framer-motion";
export var LoadingView = function (_a) {
    var label = _a.label;
    return (React.createElement("main", { className: "flex flex-col items-center min-h-screen" }, label && (React.createElement(motion.div, { initial: { y: 0, opacity: 0 }, animate: { y: 0, opacity: 1 }, transition: { delay: 0.3 } },
        React.createElement("h1", { className: "font-highlight text-7xl", style: { paddingTop: "25vh" } }, label)))));
};
//# sourceMappingURL=LoadingView.js.map